// Functie om een voorloopnul toe te voegen
function addLeadingZero(number) {
  return (number < 10 ? '0' : '') + number;
}

// Functie om de timer bij te werken
function updateTimer() {
  // Huidige tijd
  var now = new Date();

  // Tijd tot middernacht
  var midnight = new Date();
  midnight.setHours(24, 0, 0, 0); // Set naar middernacht

  // Verschil tussen de huidige tijd en middernacht
  var timeLeft = midnight - now;

  // Omrekenen naar uren, minuten en seconden
  var hours = Math.floor(timeLeft / (1000 * 60 * 60));
  var minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  // Voeg een voorloopnul toe aan uren, minuten en seconden indien nodig
  hours = addLeadingZero(hours);
  minutes = addLeadingZero(minutes);
  seconds = addLeadingZero(seconds);

  // Weergave van de tijd over in de HTML

  // document.getElementById('deal-timer-2:').innerHTML = hours + ":" + minutes + ":" + seconds;
  document.getElementById('deal-timer-1:').innerHTML = hours + ":" + minutes + ":" + seconds;
  document.getElementById('deal-timer-').innerHTML = hours + ":" + minutes + ":" + seconds;
  
  
}

// Update de timer elke seconde
setInterval(updateTimer, 1000);